export function ClassNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
  
export function getPostionCSSClass(position) {
  switch (position) {
    case "top_left":
      return "justify-start items-start";
    case "top_center":
      return "justify-center items-start";
    case "top_right":
      return "justify-end items-start";
    
    case "center_left":
      return "justify-start items-center";
    case "center_center":
      return "justify-center items-center";
    case "center_right":
      return "justify-end items-center";
    
    case "bottom_left":
      return "justify-start items-end";
    case "bottom_center":
      return "justify-center items-end";
    case "bottom_right":
      return "justify-end items-end";
    
    default:
      return "justify-end items-end";
  }
}